module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "ct"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm01"
    }
  }, [_vm._v("Preface: The Road to Ballymongan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm02"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1 Goals and Orientations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Aghyaran: A Sense of Place and History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Ceilis as Storytelling Contexts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Wakes as Storytelling Contexts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Local Character Anecdotes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The Wider Range of Storytelling Genres")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Anecdotes and the Literary Character")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Anecdotes and the Local Character")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Anecdote Cycles and Personality Traits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Patterns and Implications")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Storytelling, Commemoration, and Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0